import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LastActivity',
  props: {
    lastActivity: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'homepage.lastActivity',
    },
  },
  setup(__props) {

  

  const { formatDate, daysDifferenceFromNow } = useCommonMixin()
  const { translateString } = useI18n()

  const daysDifference = computed(() => {
    return (date: string) => {
      if (!daysDifferenceFromNow(date)) return ''
      const difference = translateString('homepage.daysAgo', { days: daysDifferenceFromNow(date) })
      return `(${difference})`
    }
  })

return { __sfc: true,formatDate, daysDifferenceFromNow, translateString, daysDifference, computed, useCommonMixin, useI18n }
}

})